import {
  sbIconHeartAnimation,
  sbIconLinkAnimation,
  sbIconMatterportAnimation,
  sbIconPhotoAnimation,
  sbIconVideoAnimation,
  sbIconWordAnimation
} from '@ngx-seatback/icons'
import {FileDummyItem} from './file-dummies';

export type FileTypes = 'IMAGE' | 'VIDEO' | 'POWERPOINT' | 'MATTERPORT' | 'WORD' | 'UNKNOWN';

export const FileDummyTypes: Map<string, FileTypes> = new Map<string, FileTypes>(
  [
    ['jpeg', 'IMAGE'],
    ['jpg', 'IMAGE'],
    ['png', 'IMAGE'],

    ['mp4', 'VIDEO'],

    ['pptx', 'POWERPOINT'],
    ['docx', 'WORD'],
    ['matterport', 'MATTERPORT']
  ]);


export const FileDummies: Map<FileTypes | string, FileDummyItem> = new Map<FileTypes | string, FileDummyItem>(
  [
    ['IMAGE', {color: '#F18797', fileName: 'IMAGE', icon: sbIconPhotoAnimation}],
    ['VIDEO', {color: '#F18797', fileName: 'VIDEO', icon: sbIconVideoAnimation}],
    ['POWERPOINT', {color: '#F18797', fileName: 'VIDEO', icon: sbIconVideoAnimation}],
    ['WORD', {color: '#25457C', fileName: 'DOCX', icon: sbIconWordAnimation}],
    ['MATTERPORT', {color: '#C5293C', fileName: 'MATTERPORT', icon: sbIconMatterportAnimation}],
    ['LINK', {color: '#c5c5c5', fileName: 'LINK', icon: sbIconLinkAnimation}],
    ['IFRAME', {color: '#c5c5c5', fileName: 'IFRAME', icon: sbIconLinkAnimation}],
    ['UNKNOWN', {color: '#c5c5c5', fileName: 'Undefined', icon: sbIconHeartAnimation}],
  ]);
